var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94305793,7.01230254 C8.77138583,6.91433307 8.55209544,7.03191609 8.55209544,7.22274273 L8.55209544,16.7768355 C8.55209544,16.9674655 8.77145826,17.0856384 8.94349252,16.9880131 C8.94359599,16.9880131 8.94338904,16.9881114 8.94349252,16.9880131 L17.3225729,12.2110551 C17.4894749,12.1159859 17.4896818,11.8847524 17.3227798,11.7895849 L8.94305793,7.01230254 Z M9.7419111,5.74793108 C8.5353742,5.05968695 7,5.8858945 7,7.22274273 L7,16.7768355 C7,18.1139 8.53528107,18.9395374 9.74146617,18.2529154 L18.1209707,13.4756626 C19.2930098,12.8079168 19.2930098,11.1927232 18.1209707,10.5248792 L9.7419111,5.74793108 C9.74181798,5.74788192 9.74200423,5.74799006 9.7419111,5.74793108 Z",
    id: "Shape",
    fill: "currentColor"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlay);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "static/media/iconPlay.071f5396a7d5c7d1d9b9dc9d06fd8e7d.svg";
export { MemoForwardRef as ReactComponent };